import $ from "jquery";
$(document).on("click", ".garageCell__button", function(e) {
	var selected_garage_main = $(".garageCell__button");
	if (!selected_garage_main.hasClass("garageCell__button--selected")) {
		$(this).addClass("garageCell__button--selected");
	} else {
		selected_garage_main.removeClass("garageCell__button--selected");
		$(this).addClass("garageCell__button--selected");
	}
});
